import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InviteService } from '@app/invite.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BehaviorSubject, Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-directory',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AngularSvgIconModule,
    FormsModule
  ],
  templateUrl: './directory.component.html',
  styleUrls: ['./directory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectoryComponent {

  public desktop = new BehaviorSubject(true);
  public email: string | undefined;
  public success = new Subject<void>();

  private destroyed = new Subject<void>();

  constructor(
    private readonly responsive: BreakpointObserver,
    private readonly inviteService: InviteService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.responsive.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
    ])
    .pipe(
      takeUntil(this.destroyed)
    )
    .subscribe(result => {
      if (result.matches) {
        this.desktop.next(false);
      } else {
        this.desktop.next(true);
      }
    });
  }

  inviteBackpacker() {
    if (this.email) {
      this.inviteService.inviteBackpacker(this.email)
        .pipe(
          tap(res => {
            this.email = 'Success!'
            this.cd.detectChanges();
          }),
        )
        .subscribe()
    }
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
